import { render, staticRenderFns } from "./datatable-header-with-sorting-and-filtering.vue?vue&type=template&id=0ba0118a&scoped=true&"
import script from "./datatable-header-with-sorting-and-filtering.vue?vue&type=script&lang=ts&"
export * from "./datatable-header-with-sorting-and-filtering.vue?vue&type=script&lang=ts&"
import style0 from "./datatable-header-with-sorting-and-filtering.vue?vue&type=style&index=0&id=0ba0118a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba0118a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBadge,VBtn,VIcon})
